import SectorQueue from './SectorQueue'

function Inspection() {
    return <SectorQueue sector="Inspeção" />
}

export default Inspection
